import { withStyles } from "@material-ui/core/styles";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

const styles = (theme) => ({
  displayMessage: {
    display: "flex",
    paddingLeft: 8,
  },
  dispatchMessage: {
    fontSize: "20px",
    paddingTop: "2px",
    cursor: "pointer",
    color: "theme.iconColor",
  },
});

const Message = ({ classes, onClick, driverId }) => {
  return (
    <div className={classes.displayMessage}>
      <MailOutlineIcon
        className={classes.dispatchMessage}
        onClick={(e) => onClick(e, driverId)}
      />
    </div>
  );
};

export default withStyles(styles)(Message);
